import { createRoot } from 'react-dom/client';
import AdminApp from './components/AdminApp';
import React from 'react';

const view = document.getElementById('admin_app');
if (view) {
  var instituteId = view.getAttribute('data-institute-id');
  var institute = window.institutes.find((institute) => institute.id == instituteId);
  const user = window.current_user;
  var hideHome = user.is_facilitator && !user.is_any_supervisor && !user.is_any_admin;
  const root = createRoot(view);
  root.render(<AdminApp user={user} institutes={window.institutes} institute={institute} hideHome={hideHome} />);
}
